import React from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles, withStyles} from '@material-ui/core/styles';

import MenuItem from '@material-ui/core/MenuItem';

import InputBase from '@material-ui/core/InputBase';

import Select from '@material-ui/core/Select';
import Box from '@material-ui/core/Box';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {ErrorMessage} from 'formik';

const useStyles = makeStyles((theme) => ({
  label: (props) => ({
    fontSize: '.9rem',
    fontWeight: props.labelBold ? 700 : 300,
    marginBottom: theme.spacing(1),
  }),
  root: {
    width: '100%',
  },
  rightButton: {
    border: '1px solid #797979',
    borderTopRightRadius: 25,
    borderBottomRightRadius: 25,
    borderLeft: 'none',
    outline: 'none',
    padding: '0 10px',
    cursor: 'pointer',
  },
  error: {
    fontSize: '.8rem',
    height: 19,
    marginTop: 1,
    marginBottom: 2,
    color: 'red',
    fontWeight: 'normal',
  },
}));

const CustomInput = withStyles((theme) => ({
  root: {
    width: '100%',
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: (props) => ({
    borderTopLeftRadius: props.hasSelect ? 0 : 25,
    borderBottomLeftRadius: props.hasSelect ? 0 : 25,
    borderTopRightRadius: props.rightButtonIcon ? 0 : 25,
    borderBottomRightRadius: props.rightButtonIcon ? 0 : 25,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #797979',
    fontSize: 16,
    padding: '6px 20px',
    boxShadow: 'none',
    '&:focus': {
      borderRadius: 25,
      boxShadow: 'none',
      borderTopLeftRadius: props.hasSelect ? 0 : 25,
      borderBottomLeftRadius: props.hasSelect ? 0 : 25,
      border: '1px solid #797979',
    },
  }),
}))(InputBase);

export const SelectCustomInput = withStyles((theme) => ({
  root: {
    maxWidth: 60,
  },
  input: (props) => ({
    borderRadius: 25,
    borderTopRightRadius: props.hasSelect ? 0 : 25,
    borderBottomRightRadius: props.hasSelect ? 0 : 25,
    position: 'relative',
    fontWeight: 600,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #797979',
    fontSize: 16,
    padding: '6px 10px',
    boxShadow: 'none',
    borderRight: 0,
    minWidth: 30,
    '&:focus': (props) => ({
      borderRadius: 25,
      borderRight: 0,
      backgroundColor: theme.palette.common.white,
      boxShadow: 'none',
      borderTopRightRadius: props.hasSelect ? 0 : 25,
      borderBottomRightRadius: props.hasSelect ? 0 : 25,
      border: '1px solid #797979',
    }),
  }),
}))(InputBase);

const AppFormControl = ({
  label,
  hasSelect,
  selectItems = [],
  hasFormik,
  selectValue,
  value,
  name,
  selectName,
  labelBold,
  handleChange,
  rightButtonIcon,
  handleRightButton,
  ...props
}) => {
  const classes = useStyles({hasSelect, labelBold});

  return (
    <div className={classes.root}>
      <Typography color="textPrimary" className={classes.label}>
        {label}
      </Typography>
      <Box display="flex" flexDirection="column">
        <Box display="flex">
          {hasSelect && (
            <Select
              value={selectValue}
              name={selectName}
              IconComponent={ExpandMoreIcon}
              onChange={handleChange}
              input={<SelectCustomInput hasSelect={hasSelect} />}
            >
              {selectItems.map(({value, text}) => (
                <MenuItem value={value}>{text}</MenuItem>
              ))}
            </Select>
          )}
          <CustomInput
            {...props}
            hasSelect={hasSelect}
            value={value}
            onChange={handleChange}
            name={name}
            rightButtonIcon={rightButtonIcon}
          />
          {rightButtonIcon && (
            <button className={classes.rightButton} onClick={handleRightButton}>
              {rightButtonIcon}
            </button>
          )}
        </Box>
        {hasFormik && (
          <Box className={classes.error}>
            <ErrorMessage name={name} />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default AppFormControl;
